import React from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import getConfig from 'next/config';
import dynamic from 'next/dynamic';
import SectionTitle from 'components/Section/SectionTitle';
import ContestContent from 'components/ContestContent';
import Section from 'components/Section';
import ArticleImage from 'components/ArticleImage';
import VoteSection from './VoteSection';

const Tags = dynamic(() => import('components/Tags'), { ssr: true });
const ShareButtons = dynamic(() => import('components/ShareButtons'), { ssr: false });

const SkyscraperMobile = dynamic(() => import('components/Ads/SkyscraperMobile'), {
    ssr: false
});

const Wideboard = dynamic(() => import('components/Ads/Wideboard'), {
    ssr: false
});

const Title = styled.h1`
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.41;
    letter-spacing: normal;
    text-align: left;
    color: #707070;
`;

interface Props {
    contest: POYContest | QuizContest;
    content?: string;
    isExpired: boolean;
    ads: PageAds;
}

const ContestDetails = ({ contest, content, isExpired, ads }: Props): JSX.Element => {
    const {
        name,
        openingImage,
        openingImageInfo,
        seoTitle,
        seoDescription,
        teaser,
        seoSlug,
        tags
    } = contest;

    const { url } = getConfig().publicRuntimeConfig;
    const { skyscraper, wideboardBottom } = ads;

    return (
        <Row
            gutter={16}
            style={{
                flexWrap: 'wrap',
                display: 'flex'
            }}
        >
            <Col span={24}>
                <article>
                    <Row>
                        <Col span={24}>
                            <Title>{name}</Title>
                        </Col>
                        <Col span={24}>
                            <ArticleImage
                                type="opening"
                                image={openingImage}
                                alt={seoTitle}
                                copyright={openingImageInfo?.copyright}
                                width={1200}
                                height={675}
                                priority
                            />
                        </Col>

                        <Col span={24}>
                            <Section justify="end" $marginTop={25}>
                                <Col>
                                    <ShareButtons
                                        title={seoTitle || name}
                                        teaser={seoDescription || teaser}
                                        url={`${url}/konkursy/${seoSlug}`}
                                    />
                                </Col>
                            </Section>
                        </Col>
                        <Col span={24}>
                            <Row>
                                <Col xs={24} md={12}>
                                    <SkyscraperMobile
                                        id={skyscraper[0]}
                                        margin="35px auto 0 auto"
                                    />
                                </Col>
                                <Col xs={24} md={12}>
                                    <SkyscraperMobile
                                        id={skyscraper[1]}
                                        margin="35px auto 0  auto"
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col sm={24} md={24}>
                            {content.length > 0 && (
                                <ContestContent content={content} contest={contest} />
                            )}
                        </Col>
                    </Row>

                    {!isExpired && <VoteSection contest={contest} />}

                    {isExpired && (
                        <Section>
                            <Col span={24}>
                                <SectionTitle
                                    level={2}
                                    title="Wyniki są jeszcze przetwarzane, o wynikach zostaniesz poinformowany mailowo."
                                />
                            </Col>
                        </Section>
                    )}

                    {tags.length > 0 && (
                        <Section>
                            <Col span={24}>
                                <SectionTitle level={2} title="Tagi" />
                            </Col>
                            <Col style={{ marginTop: 10, paddingBottom: '40px' }}>
                                <Tags tags={tags} />
                            </Col>
                        </Section>
                    )}
                </article>
            </Col>
            <Col span={24}>
                <Wideboard id={wideboardBottom[0]} />
            </Col>
        </Row>
    );
};

export default ContestDetails;
